import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import PointLocation from '../../algorithm/PointLocation';
import TopologyException from '../../geom/TopologyException';
import MaximalEdgeRing from './MaximalEdgeRing';
import CoordinateArrays from '../../geom/CoordinateArrays';
import ArrayList from '../../../../../java/util/ArrayList';
import Assert from '../../util/Assert';
import PlanarGraph from '../../geomgraph/PlanarGraph';
var PolygonBuilder = /*#__PURE__*/function () {
  function PolygonBuilder() {
    _classCallCheck(this, PolygonBuilder);
    PolygonBuilder.constructor_.apply(this, arguments);
  }
  _createClass(PolygonBuilder, [{
    key: "sortShellsAndHoles",
    value: function sortShellsAndHoles(edgeRings, shellList, freeHoleList) {
      for (var it = edgeRings.iterator(); it.hasNext();) {
        var er = it.next();
        if (er.isHole()) freeHoleList.add(er);else shellList.add(er);
      }
    }
  }, {
    key: "computePolygons",
    value: function computePolygons(shellList) {
      var resultPolyList = new ArrayList();
      for (var it = shellList.iterator(); it.hasNext();) {
        var er = it.next();
        var poly = er.toPolygon(this._geometryFactory);
        resultPolyList.add(poly);
      }
      return resultPolyList;
    }
  }, {
    key: "placeFreeHoles",
    value: function placeFreeHoles(shellList, freeHoleList) {
      for (var it = freeHoleList.iterator(); it.hasNext();) {
        var hole = it.next();
        if (hole.getShell() === null) {
          var shell = PolygonBuilder.findEdgeRingContaining(hole, shellList);
          if (shell === null) throw new TopologyException('unable to assign hole to a shell', hole.getCoordinate(0));
          hole.setShell(shell);
        }
      }
    }
  }, {
    key: "buildMinimalEdgeRings",
    value: function buildMinimalEdgeRings(maxEdgeRings, shellList, freeHoleList) {
      var edgeRings = new ArrayList();
      for (var it = maxEdgeRings.iterator(); it.hasNext();) {
        var er = it.next();
        if (er.getMaxNodeDegree() > 2) {
          er.linkDirectedEdgesForMinimalEdgeRings();
          var minEdgeRings = er.buildMinimalRings();
          var shell = this.findShell(minEdgeRings);
          if (shell !== null) {
            this.placePolygonHoles(shell, minEdgeRings);
            shellList.add(shell);
          } else {
            freeHoleList.addAll(minEdgeRings);
          }
        } else {
          edgeRings.add(er);
        }
      }
      return edgeRings;
    }
  }, {
    key: "buildMaximalEdgeRings",
    value: function buildMaximalEdgeRings(dirEdges) {
      var maxEdgeRings = new ArrayList();
      for (var it = dirEdges.iterator(); it.hasNext();) {
        var de = it.next();
        if (de.isInResult() && de.getLabel().isArea()) if (de.getEdgeRing() === null) {
          var er = new MaximalEdgeRing(de, this._geometryFactory);
          maxEdgeRings.add(er);
          er.setInResult();
        }
      }
      return maxEdgeRings;
    }
  }, {
    key: "placePolygonHoles",
    value: function placePolygonHoles(shell, minEdgeRings) {
      for (var it = minEdgeRings.iterator(); it.hasNext();) {
        var er = it.next();
        if (er.isHole()) er.setShell(shell);
      }
    }
  }, {
    key: "getPolygons",
    value: function getPolygons() {
      var resultPolyList = this.computePolygons(this._shellList);
      return resultPolyList;
    }
  }, {
    key: "findShell",
    value: function findShell(minEdgeRings) {
      var shellCount = 0;
      var shell = null;
      for (var it = minEdgeRings.iterator(); it.hasNext();) {
        var er = it.next();
        if (!er.isHole()) {
          shell = er;
          shellCount++;
        }
      }
      Assert.isTrue(shellCount <= 1, 'found two shells in MinimalEdgeRing list');
      return shell;
    }
  }, {
    key: "add",
    value: function add() {
      if (arguments.length === 1) {
        var graph = arguments[0];
        this.add(graph.getEdgeEnds(), graph.getNodes());
      } else if (arguments.length === 2) {
        var dirEdges = arguments[0],
          nodes = arguments[1];
        PlanarGraph.linkResultDirectedEdges(nodes);
        var maxEdgeRings = this.buildMaximalEdgeRings(dirEdges);
        var freeHoleList = new ArrayList();
        var edgeRings = this.buildMinimalEdgeRings(maxEdgeRings, this._shellList, freeHoleList);
        this.sortShellsAndHoles(edgeRings, this._shellList, freeHoleList);
        this.placeFreeHoles(this._shellList, freeHoleList);
      }
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._geometryFactory = null;
      this._shellList = new ArrayList();
      var geometryFactory = arguments[0];
      this._geometryFactory = geometryFactory;
    }
  }, {
    key: "findEdgeRingContaining",
    value: function findEdgeRingContaining(testEr, shellList) {
      var testRing = testEr.getLinearRing();
      var testEnv = testRing.getEnvelopeInternal();
      var testPt = testRing.getCoordinateN(0);
      var minShell = null;
      var minShellEnv = null;
      for (var it = shellList.iterator(); it.hasNext();) {
        var tryShell = it.next();
        var tryShellRing = tryShell.getLinearRing();
        var tryShellEnv = tryShellRing.getEnvelopeInternal();
        if (tryShellEnv.equals(testEnv)) continue;
        if (!tryShellEnv.contains(testEnv)) continue;
        testPt = CoordinateArrays.ptNotInList(testRing.getCoordinates(), tryShellRing.getCoordinates());
        var isContained = false;
        if (PointLocation.isInRing(testPt, tryShellRing.getCoordinates())) isContained = true;
        if (isContained) if (minShell === null || minShellEnv.contains(tryShellEnv)) {
          minShell = tryShell;
          minShellEnv = minShell.getLinearRing().getEnvelopeInternal();
        }
      }
      return minShell;
    }
  }]);
  return PolygonBuilder;
}();
export { PolygonBuilder as default };